<template>
<!--  <v-responsive class="overflow-y-auto" :max-height="$store.state.maxHeight">-->
  <div id="about">
      <v-card v-for="(item, i) in picArr" :key="i" min-width="50vw">
        <section id="stats">
          <!-- src="https://images.unsplash.com/photo-1510915228340-29c85a43dcfe?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=1950&q=80" -->
          <v-parallax :height="$vuetify.breakpoint.smAndDown ? '800' : '600'" :src="item.src">
            <v-card
              :class="i%2 == 0 ?'mx-auto mr-12':'mx-auto ml-12'"
              max-width="60%"
            >
              <v-card-title>
                <v-icon
                  large
                  left
                >
                  mdi-language-java
                </v-icon>
                <span class="title font-weight-light">{{ item.title }}</span>
              </v-card-title>

              <v-card-text>
                {{ item.desc }}
              </v-card-text>

              <v-card-actions>
                <v-list-item class="grow">
                  <v-img
                    :src="item.logo"
                    max-height="5vh"
                    max-width="5vw"
                    contain
                  ></v-img>

                  <v-list-item-content>
                    <v-list-item-title>&nbsp;{{ item.company }}</v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
              </v-card-actions>
            </v-card>
          </v-parallax>
        </section>
      </v-card>
  </div>
<!--</v-responsive>-->
</template>
<script>
  export default {
    name: 'account-head',
    data() {
      return {
        picArr:[
          {src:'../../../static/research/one.jpg',logo:'../../../static/research/logo/tq.png',company:'济南公安天桥区分局',title:'济南公安天桥区分局有奖举报',desc:'创新配套具有‘天桥特色’的有奖举报工作机制，是为了为了进一步拓展警民联系渠道，广泛发动群众，广辟线索来源，严厉打击辖区违法犯罪，提高群众对于公安工作的认可度，共同打造‘法治天桥、平安天桥、和谐天桥’。'},
          {src:'../../../static/research/three.jpg',logo:'../../../static/research/logo/hyqzf.png',company:'济南槐荫区政府',title:'济南槐荫智脑中心',desc:'负责济南市槐荫区经济和信息化局槐荫智脑中心信息系统集成服务项目的建设内容的智慧工具箱及智脑应用部分建设。智慧工具箱为智脑中心业务正常运行提供支撑，开发消息分发管理系统、数据对接平台，与大屏厂商对接可视化数据。智脑应用部分主要负责改造SOP城市事件处置系统提升政府治理与服务水平，让城市运行更高效。'},
          {src:'../../../static/research/two.jpg',logo:'../../../static/research/logo/td.png',company:'天地伟业',title:'重庆航道局航道管理系统',desc:'该项目主要应用于航道内的航标管理，对航道航标内的航标进行识别管理，对航行船只进行实时位置与历史轨迹展示。航标用以提供舰船定位、导航，指示碍航物，表示警告和作其他专门用途而设置的人工标志。助航标志的简称。通常设置在通航水域及其附近的水上或陆上，标示航道、锚地、浅滩、碍航物等，或作为定位、转向及测速、较正罗经等标志，航标也用以传递信号，标示水深，预告风情，指引狭窄水道交通和标示定线通航制等。永久性航标的位置、特征、灯质、信号等。'},
          {src:'../../../static/research/four.jpg',logo:'../../../static/research/logo/td.png',company:'天地伟业',title:'宁河雪亮工程',desc:'系统能按照指定设备、指定通道进行图像的实时点播，支持点播图像的显示、缩放、抓拍和录像，支持多用户对同一图像资源的同时点播。居民可在家中广电网络电视上选择雪亮工程按钮进入监控画面，选择相关视频监控点位实现实时监控视频播放。能通过手动或自动操作，对前端设备的各种动作进行遥控；应能设定控制优先级，对级别高的用户请求应有相应措施保证优先响应。监控控制平台的数据库在记录图像信息的同时还应记录与图像信息相关的检索信息，如设备、通道、时间、报警信息等。图像分辩率采用高清标准，存储视频信息不少于30天。能按照指定设备、通道、时间、报警信息等要素检索历史图像资料并回放和下载；回放应支持正常播放、快速播放、画面暂停、图像抓拍等。'},
          {src:'../../../static/research/five.jpg',logo:'../../../static/research/logo/dw.png',company:'国家电网',title:'长春国家电网短信平台',desc:'基于业务系统对短信验证码、群发等短信功能的需求以及特殊的网络环境，设计并开发短信平台，为业务调用提供便利'},
          {src:'../../../static/research/six.jpg',logo:'../../../static/research/logo/hy.png',company:'恒逸石化',title:'浙江恒逸石化营销闭环系统',desc:'营销闭环系统旨在打通恒逸石化各个系统之间的数据壁垒，实现客户系统（ERP）、销售系统（SAP）、物流系统（TMS）、微商城等系统的数据通过闭环系统进行交互，实现数据互通，营销闭环。'},
          {src:'../../../static/research/seven.jpg',logo:'../../../static/research/logo/logo.png',company:'山东巨彩',title:'山东巨彩ERP系统',desc:'集进货，销货，退货，仓储，收款，客户管理，工资管理，员工管理，和小程序配置一体的综合管理平台。实现数据一键导出，导入。一键审核。一键对账等多种实用功能。以减少工作中冗余复杂的工作流程。简化工作，提高效率。'},
          {src:'../../../static/research/eight.jpg',logo:'../../../static/research/logo/logo.png',company:'山东巨彩',title:'山东巨彩销售管理平台(微信小程序)',desc:'山东巨彩销售管理平台 接入山东巨彩ERP系统 获取ERP销货单及明细，业务员从该平台进行设备的在线收款（支撑微信和支付宝收款）、在线报备。简化收款和报备流程，提高工作效率。业务员还能再平台内进行工资明细，带薪假期，奖金明细查询。'},
          {src:'../../../static/research/nine.jpg',logo:'../../../static/research/logo/td.png',company:'天地伟业',title:'天地伟业明厨亮灶',desc:'2014年2月，国家食药监总局部署各地在餐饮业开展明厨亮灶工作；从2015年起，正式在全国推广，推动餐饮服务提供者通过采用透视明档（透明玻璃窗或玻璃幕墙）、视频显示、隔断矮墙、开放式厨房或设置窗口等多种形式，对餐饮食品加工过程进行公示，将餐饮服务关键部位与环节置于社会监督之下。通过系统对多家餐饮后厨进行小目标(蟑螂、老鼠、苍蝇等)、厨师帽、口罩等进行检测并报警'},
          {src:'../../../static/research/ten.jpg',logo:'../../../static/research/logo/td.png',company:'天地伟业',title:'天地伟业视频图像综合服务平台',desc:'该系统用于城市道路或高速公路出入口、收费站等重点治安地段的全天候实时检测与记录。可自动识别过往路口车辆号牌、颜色等特征，验证出车辆的合法身份，自动核对黑名单库，自动报警。可对路口情况进行监控与管理，包括出入口车辆管理、采集、存储数据和系统工作状态，以便于警务人员及相关部门对道路的安全进行监控。整个系统具有管理维护、统计、查询及报表打印等功能，实现对交通违法、肇事逃逸等嫌疑车辆的监控与处置。全天候记录，识别率95%以上，图片显示汉字、字母、数字，清晰可辨。'},
          {src:'../../../static/research/eleven.jpg',logo:'../../../static/research/logo/qj.png',company:'中国青建',title:'中国青建集团商务板块',desc:'青建集团商务板块主要包含合同管理、物资租赁管理、造价管理等模块，同步招采、集采、造价系统（福莱/广联达）、财务系统数据，物资管理同步物资总控计划、物资需用计划、租赁需用计划。合同模块包含合同信息、班组协议、补充协议、临时合同、合同履行情况分析等功能，物资管理模块包含物资计划、物资出入库、盘点结算等功能。租赁模块包含租赁计划、进场验收、结算付款、退场、周转材、设备成本归集等功能。'},
        ]
      }
    },
    methods: {
    },
    mounted(){

    }
  }
</script>



// WEBPACK FOOTER //
// src/page/research/research.vue